import projectsModel from '$$projectModel';
import multiViewsProjects from '$$multiviewModel';
import ganttViewModel from '$$ganttViewModel';

export default function (instance, ganttData) {
  instance.ganttDataApi.getAllProjects = projectId => {
    if (!ganttData) {
      return projectsModel.getAllProjects();
    }

    return ganttData.allProjectsData;
  };

  instance.ganttDataApi.getProjectItem = projectId => {
    if (!ganttData) {
      return projectsModel.getItem(projectId);
    }

    return ganttData.projectData;
  };

  instance.ganttDataApi.getMultiviewItem = multiviewId => {
    if (!ganttData) {
      return multiViewsProjects.getItem(multiviewId);
    }

    return ganttData.projectData;
  };

  instance.ganttDataApi.getActiveProjectId = () => {
    if (!ganttData) {
      return projectsModel.getActiveGanttId();
    }

    return ganttData.projectData?.id;
  };

  instance.ganttDataApi.getActiveProjectData = () => {
    if (!ganttData) {
      return ganttViewModel.getActiveProjectData();
    }

    return ganttData.projectData;
  };

  instance.ganttDataApi.getActiveProjectConfig = () => {
    if (!ganttData) {
      return ganttViewModel.getProjectConfig();
    }

    return ganttData.projectData?.config;
  };

  instance.ganttDataApi.getProjectConfigById = projectId => {
    if (!ganttData) {
      return projectsModel.getProjectConfig(projectId);
    }

    return ganttData.projectData?.config;
  };

  instance.ganttDataApi.isProjectArchived = projectId => {
    if (!ganttData) {
      return projectsModel.isArchived(projectId);
    }

    return !!ganttData.projectData?.is_archived;
  };

  instance.ganttDataApi.getTasksForMultiView = projectIds => ganttViewModel.getTasksForMultiView(projectIds);
}
